import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import theme from '../../../theme';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';


/* Only for Devices */

const styles = {
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    display: 'flex',
    height: '100%',
  },
  drawerPaper: {
      width: 150,
      // position: 'relative',
      whiteSpace: 'nowrap',
      height: '100%',
      backgroundColor:"yellow",
      transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
      }),
      [theme.breakpoints.down('sm')]: {
          width: 150,
      },
      [theme.breakpoints.down('xs')]: {
          minWidth: 150,
          width: '20%',
          maxWidth: 150,
          position: 'absolute',
      },
  },
  drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
      }),
  },
  drawerHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 4px 4px 27px',
      boxSizing: 'border-box',
      position: 'absolute',
      width: '100%',
      height: 64,
      [theme.breakpoints.down('sm')]: {
          paddingLeft: 16,
      },
      [theme.breakpoints.down('xs')]: {
          paddingLeft: 16,
      },
  },
  closeIcon: {
      color: theme.palette.primary.main,
  },
  changed: {
      backgroundColor: theme.palette.primary.dark,
      padding: '4px 4px 4px 27px',
      [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing.unit * 2,
      },
  },
  changedText: {
      color: 'white',
  },
  deletionBackground: {
      backgroundColor: theme.palette.error.dark,
      padding: '4px 4px 4px 27px',
      [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing.unit * 2,
      },
  },
  deletionText: {
      color: '#fff',
      fill: 'fff',
  },
  rangeErrors: {
      // color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
  },
};

export class SidebarContent extends PureComponent {
    static propTypes = {
      children: PropTypes.node,
    }

    static defaultProps = {
      children: null,
    }

    render () {
      return (
        <div style={{ position: 'relative', top: 70 }}>
            {this.props.children}
        </div>
      );
    }
}

export class SidebarHeader extends PureComponent {
    static propTypes = {
      title: PropTypes.string.isRequired,
      onClose: PropTypes.func.isRequired,
    }

    static defaultProps = {
    }

    render () {
        const { classes } = this.props;
        return (
            <div style={styles.drawerHeader}>
                <Typography variant="h5">
                    {this.props.title}
                </Typography>
                <IconButton onClick={this.props.onClose}>
                    <CloseIcon style={styles.closeIcon}/>
                </IconButton>
            </div>
        );
    }
}



class SidebarHeaderDialog extends PureComponent {
    static propTypes = {
      title: PropTypes.string.isRequired,
      onAction: PropTypes.func.isRequired,
      onClose: PropTypes.func.isRequired, // onRequestClose
      type: PropTypes.oneOf(['info', 'critical']),
      icon: PropTypes.node,
    }

    static defaultProps = {
      type: 'info',
      icon: null,
    }

//save:
// userPwdChange PwdIcon
// newDevice
// userDelete classes.deletionText DeleteIcon
// factoryReset classes.deletionText SaveIcon
// newDevice
// ? (<ArrowIcon style={{ fill: theme.palette.custom.hoverItem }} className={classes.deletionText}/>)

    classnames () {
      const { classes } = this.props;
      return classNames((this.props.type === 'critical' && styles.deletionText) || styles.changedText);
    }

    render () {
      const { classes } = this.props;
      return (
       <div style={{...styles.drawerHeader, ...styles.changed, ...styles.deletionBackground }}> 
        {/* <div style={classNames(styles.drawerHeader, styles.changed, this.props.type === 'critical' && styles.deletionBackground)}> */}
          <IconButton onClick={this.props.onAction}>
            {this.props.icon || (<SaveIcon style={{...styles.deletionText, ...styles.changedText}} />)}
          </IconButton>
          <Typography style={{...styles.deletionText, ...styles.changedText}} variant="h5">
            {this.props.title}
          </Typography>
          <IconButton id='sidebar_header_closeBtn' onClick={this.props.onClose}>
              {/* <CloseIcon style={classNames(styles.closeIcon, this.classnames())}/>  */}
              <CloseIcon style={{...styles.closeIcon, ...styles.deletionText, ...styles.changedText }}/> 
              {/* <CloseIcon style={styles.closeIcon}/> */}
          </IconButton>
      </div>
      );
    }
}

//SidebarHeaderDialog = withStyles(styles)(SidebarHeaderDialog);
export {
  SidebarHeaderDialog
};

class Sidebar extends PureComponent {
    static propTypes = {
      open: PropTypes.bool,
      children: PropTypes.node,
    }

    static defaultProps = {
      open: false,
      children: null,
    }

    render() {
      const { classes } = this.props;
      return (
        <Drawer
                variant="persistent"
                id='sidebar_details'
                open={this.props.open}
                anchor="right"
                //classes={{ paper: classNames(classes.drawerPaper, !this.props.open && classes.drawerPaperClose) }}
                styles={{ paper: classNames(styles.drawerPaper, !this.props.open && styles.drawerPaperClose) }}
                //style={styles.drawerPaperClose}
                SlideProps={{ unmountOnExit: true }}
            >
            {this.props.children}
        </Drawer>
      );
    }
}

//export default withStyles(styles)(Sidebar);
export default Sidebar;
